export default __webpack_public_path__ + "static/media/stutitCoin.b43346c6.svg";